<template>
  <div>
    <Pane title="项目跟踪详情"/>

    <div class="container">
      <a-spin :spinning="loading">
        <Title>基本信息</Title>
        <div class="panel">
          <div class="label">项目名称</div>
          <div class="value1">{{ detail.projectName }}</div>
          <div class="label">项目类型</div>
          <div class="value2">{{ dictName(projectTrackType, detail.projectType) }}</div>

          <div class="label">项目地点</div>
          <div class="value3">{{ detail.projectLocation }}</div>

          <div class="label">分类</div>
          <div class="value1">{{ dictName(trackCategory, detail.category) }}</div>
          <div class="label">业主单位名称</div>
          <div class="value2">{{ detail.ownerCompanyName }}</div>

          <div class="label">预计合同金额(万元)</div>
          <div class="value1">{{ detail.expectedAmount }}</div>
          <div class="label">预计落地/开标时间</div>
          <div class="value2">{{ detail.expectedTime }}</div>

          <div class="label">概率(%)</div>
          <div class="value1">{{ detail.probability }}</div>
          <div class="label">是否介入方案</div>
          <div class="value2">{{ detail.isIntervene ? '是' : '否' }}</div>

          <div class="label">配合生产院</div>
          <div class="value1">{{ detail.coopCompanyName }}</div>
          <div class="label">生产院负责人</div>
          <div class="value2">{{ detail.coopLeaderName }}</div>

          <div class="label">专职经营人员</div>
          <div class="value3">{{ detail.fulltimeManagerName }}</div>
        </div>

        <Title>其他信息</Title>
        <div class="panel">
          <div class="label">概率原因</div>
          <div class="value3">{{ detail.probabilityReason }}</div>

          <div class="label">备注/当前阶段</div>
          <div class="value3">{{ detail.remark }}</div>
        </div>

        <Padding />
        <div style="text-align: center; margin: 20px 0;">
          <a-space>
            <a-button @click="$router.back()">返回</a-button>
          </a-space>
        </div>
      </a-spin>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import watermark from "@/mixins/watermark";
import { getProjectTrackDetail } from "@/api/market/projectTrack";
import Title from "@/views/approval/task/components/Title";

export default {
  components: { Title },
  mixins: [watermark],
  data() {
    return {
      loading: false,
      detail: {},
    };
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    projectTrackType() {
      return this.findDataDict("projectTrackType");
    },
    trackCategory() {
      return this.findDataDict("trackCategory");
    },
  },
  mounted() {
    const id = this.$route.query.id;
    if (id) {
      this.loadDetail(id);
    }
  },
  methods: {
    dictName(list, value) {
      const item = list.find((i) => i.value === value);
      return item ? item.name : value;
    },
    loadDetail(id) {
      this.loading = true;
      getProjectTrackDetail(id)
        .then((res) => {
          this.detail = { ...res };
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px;
}
.panel {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid #e8e8e8;

  & > div {
    padding: 8px;
    border-bottom: 1px solid #e8e8e8;
  }

  .label {
    background-color: #fafafa;
    border-right: 1px solid #e8e8e8;
    border-left: 1px solid #e8e8e8;
  }

  .value1 {
    grid-column-start: 2;
    grid-column-end: 4;
  }

  .value2 {
    grid-column-start: 5;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }

  .value3 {
    grid-column-start: 2;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }
}
</style>
